import { Language } from './companyConstants';

export const supportEmails: Record<Language, string> = {
	sk: 'pomoc@wagenow.sk',
	en: 'help@wagenow.co.uk',
};

export const loginPaths: Record<Language, string> = {
	sk: 'https://ewa.wagenow.com/sk/login',
	en: 'https://ewa.wagenow.com/en/login',
};

export const ewaDomains: Record<Language, string> = {
	sk: 'https://ewa.wagenow.com/sk',
	en: 'https://ewa.wagenow.com/en',
};

export const publicDomains: Record<string, string> = {
	sk: 'https://www.wagenow.sk',
	com: 'https://www.wagenow.com',
	uk: 'https://www.wagenow.co.uk',
};

export const adminDomain = 'https://admin.wagenow.sk';
